import React from 'react';
import './Footer.css';
import { FaFacebookF, FaInstagram, FaYoutube, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import logo from '../assets/logo.png'; // Update this path to your actual logo file

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-top">
        {/* Logo & About */}
        <div className="footer-col logo-col">
          <img src="\Jyotish-Karmaa-logo.png" alt="Acharya Logo" className="footer-logo" />
          <p>
            Preserving ancient Indian wisdom through spiritual, cultural, and educational programs.
          </p>
        </div>

        {/* Quick Links */}
        <div className="footer-col">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/about">About</a></li>
            <li><a href="/courses">Courses</a></li>
            <li><a href="/gauseva">Gauseva</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-col">
          <h4>Contact</h4>
          <p><FaPhoneAlt /> +91- 79055 13982</p>
          <p><FaEnvelope /> jyotishkarmaa@gmail.com</p>
          <p></p>
        </div>

        {/* Social Media */}
        <div className="footer-col">
          <h4>Follow Us</h4>
          <div className="social-icons">
            <a href="https://www.facebook.com/share/1Fc4BNsf1D/"><FaFacebookF /></a>
            <a href="https://www.instagram.com/jyotishkarmaa?igsh=YXFrMjNkazFtd3Nt"><FaInstagram /></a>
            <a href="https://youtube.com/@jyotishkarmaa?si=F3WF5x-FgA22HhZN"><FaYoutube /></a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Jyotish Karmaa. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
